/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Size dropdown: list only the sizes that exist (and are available) for the
 * selected earlier options, e.g. material. The Liquid side renders the first
 * load; this keeps it right when an earlier option changes. Runs after the
 * theme's own delegated handler, then re-fires `change` on the size select so
 * the theme picks up the corrected variant. See patches/theme/mobile-pdp/README.md.
 */
(function () {
  function findContainer(el) {
    while (el && el !== document) {
      if (el.querySelector && el.querySelector('[data-product-json]') && el.querySelector('select[data-wj-size-select]')) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.classList || !target.classList.contains('product-form__single-selector')) { return; }
    if (target.hasAttribute('data-wj-size-select')) { return; }

    var container = findContainer(target);
    if (!container) { return; }

    var sizeSelect = container.querySelector('select[data-wj-size-select]');
    var sizePos = parseInt(sizeSelect.getAttribute('data-option-position'), 10);
    var changedPos = parseInt(target.getAttribute('data-option-position'), 10);
    if (!(changedPos < sizePos)) { return; }

    var json;
    try { json = JSON.parse(container.querySelector('[data-product-json]').innerHTML); } catch (e) { return; }
    var variants = json.product.variants;
    var allSizes = json.options_with_values[sizePos - 1].values;

    // Current values of the earlier options, read from the checked/selected inputs
    var current = {};
    for (var p = 1; p < sizePos; p++) {
      var input = container.querySelector('.product-form__single-selector[data-option-position="' + p + '"]:checked, select.product-form__single-selector[data-option-position="' + p + '"]');
      if (!input) { return; }
      current[p] = input.value;
    }

    function matchesEarlier(variant) {
      for (var q = 1; q < sizePos; q++) {
        if (variant['option' + q] !== current[q]) { return false; }
      }
      return true;
    }

    var valid = allSizes.filter(function (size) {
      return variants.some(function (v) { return v.available && v['option' + sizePos] === size && matchesEarlier(v); });
    });
    if (!valid.length) {
      // Nothing available: fall back to every size that exists, so the theme shows "sold out"
      valid = allSizes.filter(function (size) {
        return variants.some(function (v) { return v['option' + sizePos] === size && matchesEarlier(v); });
      });
    }
    if (!valid.length) { return; }

    var previous = sizeSelect.value;
    var next = valid.indexOf(previous) !== -1 ? previous : valid[0];

    sizeSelect.innerHTML = '';
    valid.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      if (size === next) { option.selected = true; }
      sizeSelect.appendChild(option);
    });
    sizeSelect.value = next;

    // Always re-fire: the theme computed its variant from the old size before we ran
    sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/**
 * Google Ads click-id capture (Track F, F7). Stores gclid from the landing
 * URL in a first-party cookie (90-day expiry, matching Google's own gclid
 * retention window) and mirrors it onto the cart as an attribute, which
 * Shopify carries through checkout into the order's note_attributes. See
 * analysis/tracking/DECISIONS.md and scripts/google/gclid_conversion_export.py.
 * Never fires a network call when no gclid has ever been captured.
 */
(function () {
  var COOKIE_NAME = '_wj_gclid';
  var COOKIE_TS_NAME = '_wj_gclid_ts';
  var COOKIE_DAYS = 90;

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop()) : null;
  }

  var params = new URLSearchParams(window.location.search);
  var gclid = params.get('gclid');
  if (gclid) {
    setCookie(COOKIE_NAME, gclid, COOKIE_DAYS);
    setCookie(COOKIE_TS_NAME, Date.now().toString(), COOKIE_DAYS);
  }

  var storedGclid = getCookie(COOKIE_NAME);
  if (storedGclid) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { gclid: storedGclid } })
    }).catch(function () {
      // Best-effort only; never block the page on this.
    });
  }
})();
